import React from "react";

function CompletionPopup({ title, message, hidePopup}) {

    return (
        <div className="popup-overlay" onClick={hidePopup}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-button" onClick={hidePopup}>×</button>
                <h2>{title}</h2>
                <img alt="success" style={{ maxWidth: "40%" }} src={require("../img/trophy.png")} />
                <p>{message}</p>
                <button className='primary-btn' style={{ padding: "12px 65px", fontSize: "18px" }} onClick={hidePopup}>Continue</button>

            </div>
        </div>
    )
}
export default CompletionPopup;